<div class="full-width full-height d-flex flex-direction-column">
    @if (!reviewMode) { @if (localEntity) {
    <div class="full-width full-height question-header d-flex justify-end">
        <div>
            @if (cstQuestionnaireService.instanceOfQuestion(entity.entity)) {
            <div class="fl">
                <mat-checkbox
                    [(ngModel)]="localEntity.required"
                    class="example-margin"
                    color="primary"
                >
                    Mandatory question
                </mat-checkbox>
            </div>
            } @if (cstQuestionnaireService.instanceOfQuestion(entity.entity)) {
            <div class="fl">
                <mat-checkbox
                    [(ngModel)]="localEntity.invalidate_answers"
                    class="example-margin m-l-32"
                    color="primary"
                >
                    Invalidate previous answers
                </mat-checkbox>
            </div>
            } @if (cstQuestionnaireService.instanceOfQuestion(entity.entity)) {
            <div class="fl add-conditional-check">
                <mat-checkbox
                    [(ngModel)]="localEntity.conditional_logic"
                    (change)="switchConditionalLogicOnQuestion($event, entity.entity)"
                    class="example-margin m-t-10"
                    color="primary"
                >
                    Add to conditional logic list
                </mat-checkbox>
            </div>
            }
        </div>
        <div>
            <div class="question-header-actions fr d-flex">
                @if (cstQuestionnaireService.instanceOfQuestion(entity.entity) && (!cstQuestionnaireService.currentQuestionForm ||
                (cstQuestionnaireService.currentQuestionForm && cstQuestionnaireService.currentQuestionForm.group.valid))) {
                <div>
                    <span
                        (click)="cstQuestionnaireService.copyQuestion(cstQuestionnaireService.currentSection?.id, localEntity)"
                        class="fs-24 ds-icon-copy_to_clipboard"
                    >
                    </span>
                </div>
                } @if (cstQuestionnaireService.instanceOfQuestion(entity.entity)) {
                <div>
                    <button
                        class="delete-button"
                        style="all: unset"
                        (click)="cstQuestionnaireService.deleteQuestion(cstQuestionnaireService.currentSection?.id, localEntity)"
                        [disabled]="cstQuestionnaireService.isLoading"
                    >
                        <span class="fs-24 ds-icon-delete"> </span>
                    </button>
                </div>
                } @if (cstQuestionnaireService.instanceOfSection(entity.entity) && cstQuestionnaireService.canDeleteSection()) {
                <div>
                    <button
                        class="delete-button"
                        style="all: unset"
                        (click)="cstQuestionnaireService.deleteSection()"
                    >
                        <span class="fs-24 ds-icon-delete"> </span>
                    </button>
                </div>
                }
            </div>
        </div>
    </div>
    } @if (entity && commonQuestionnaireService.createMode && cstQuestionnaireService.instanceOfQuestion(entity.entity)) {
    <div class="question-header-chip-list m-t-16">
        <mat-chip-listbox [selectable]="true">
            @for (type of QuestionTypes.getAllTypes(); track type) {
            <mat-chip (click)="addTagToQuestion(entity.entity, QuestionTypes.getName(type))">
                @if (checkServiceOffering(entity.entity, QuestionTypes.getName(type))) {
                <mat-icon class="question-header-done-icon fs-20">done</mat-icon>
                }
                {{ QuestionTypes.getName(type) }}
            </mat-chip>
            }
        </mat-chip-listbox>
    </div>
    } } @if (reviewMode) { @if (localEntity) {
    <div class="full-width full-height question-header">
        <div class="fl last-update-text fs-12">
            Last update:
            {{ localEntity?.body ? (localEntity?.body.last_update | date : 'dd MMM yyyy, HH:mm') : '-' }}
        </div>
        <div class="question-header-actions fr d-flex">
            <span
                class="fs-24 ds-icon-edit edit-icon"
                (click)="toggleReviewPanel()"
                [ngClass]="{ active: reviewPanelOpen }"
            >
            </span>
        </div>
    </div>
    } }
</div>
